import { LogEvent, TelemetryEvent, TelemetryEventType } from './types';
const logTypes = [TelemetryEventType.Info, TelemetryEventType.Error, TelemetryEventType.Performance];

export const isLogEvent = (event: TelemetryEvent): event is LogEvent => logTypes.includes(event.type);
